module.exports = __webpack_public_path__ + "static/media/emily.5b5d73d0.jpg";